import { render, staticRenderFns } from "./payError.vue?vue&type=template&id=2faed9b4&scoped=true&"
import script from "./payError.vue?vue&type=script&lang=js&"
export * from "./payError.vue?vue&type=script&lang=js&"
import style0 from "./payError.vue?vue&type=style&index=0&id=2faed9b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faed9b4",
  null
  
)

export default component.exports